import React from "react";
import "components/General/Form/Form.css";
import { DatePickerComponent } from "@syncfusion/ej2-react-calendars";

const CustomDatepicker = (props) => {
  return (
    <div className="form-group">
      <table>
        <tbody>
          <tr>
            {props.orientation === "labeled" ? (
              <td style={{ width: "25%", textAlign: "left" }}>
                {props.label}
                {props.required ? "*" : ""}
              </td>
            ) : null}
            <td style={{ width: "75%" }}>
              <DatePickerComponent
                name={props.name}
                id={props.name}
                placeholder={props.placeholder}
                value={props.value}
                onChange={props.handleChange}
                readOnly={props.readOnly ? "readOnly" : false}
                onBlur={props.handleChange}
                cssClass="e-calendar-orange"
                min={props.minDate}
              />
            </td>
          </tr>
          {props.error ? (
            <tr>
              <td className="sign-up-dob-error"></td>
              <td>
                <div
                  className="invalid-feedback text-left"
                  style={{ display: "block" }}
                >
                  {props.error}
                </div>
              </td>
            </tr>
          ) : null}
        </tbody>
      </table>
    </div>
  );
};

export default CustomDatepicker;
